import { Component } from '@angular/core';

import { MapToolsService } from '../workspace/map-tools.service';
import { PanelNavService } from '../workspace/panel-nav.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';

/**
 * Checks (#256, #260): enclaves, regions split in pieces, suburbs in a region of another state, and the same for
 * sub-regions (check-report.ts). A row flies to its suburb; unanimous enclaves can be filled in one step.
 */
@Component({
  selector: 'section[app-suburb-checks]',
  templateUrl: './suburb-checks.component.html',
  styleUrls: ['./suburb-checks.component.scss'],
})
export class SuburbChecksComponent {
  constructor(
    public state: WorkspaceStateService,
    public mapTools: MapToolsService,
    public nav: PanelNavService
  ) {}
}
